import React, { useEffect, useState } from 'react';
import moment from 'moment';
import CardOverview from '../../../components/card/CardOverview';

import CanvasJSReact_EnergyProduce from '../../../components/chart/ChartOverview_EnergyProduce';
import CanvasJSReact_EnergyBalance from '../../../components/chart/ChartOverview_EnergyBalance';
import ScrollToTopButton from '../../../components/extra/ScrollToTopButton.js';

function MeasurementOverview(props) {
    const [chart_mode, setChart_mode] = useState('daily-5m');
    const [data_chart, setData_chart] = useState({
        chart_5m: {
            XLabel: '',
            Data: [],
            Summary: {},
            CODData: {},
        },
        chart_hour: {
            XLabel: '',
            Data: [],
            Summary: {},
            CODData: {},
        },
        chart_month: {
            XLabel: '',
            Data: [],
            Summary: {},
            CODData: {},
        },
        chart_year: {
            XLabel: '',
            Data: [],
            Summary: {},
            CODData: {},
        },
        chart_cod: {
            XLabel: '',
            Data: [],
            Summary: {},
            CODData: {},
        }
    });
    const [chart_plot, setChart_plot] = useState({
        XLabel: '',
        EnergyAC: [],
        EnergyGrid: [],
        ENS: [],
        IRR: [],
        CODData: null,
        Chart1_Style: {
            irr_type: "line",
            grid_type: "area",
            solar_type: "area",
            ens_type: "area",
            irr_unit: "W/m2",
            solar_unit: "kW",
            grid_unit: "kW",
            ens_unit: "kW",
            axis_y1: 'Power (kW)',
            axis_y2: 'Irradiation (W/m2)',
            solar_tag: 'Solar Power',
            grid_tag: 'Grid Power',
            ens_tag: 'Energy not Supply',
            xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-',
            opacity: 0.8
        }
    });

    useEffect(() => {
        return () => {
            setData_chart({})
            setChart_plot({})
        };
    }, []);

    useEffect(() => {
        if (props.data_chart !== null) {
            setData_chart(props.data_chart)
        }
    }, [props.data_chart]);

    useEffect(() => {
        let daplot
        let plot_chart = null
        if (chart_mode === "daily-5m") {
            daplot = {
                XLabel: data_chart.chart_5m.XLabel,
                EnergyAC: [],
                EnergyGrid: [],
                ENS: [],
                IRR: [],
                CODData: null,
                Chart1_Style: {
                    irr_type: "line",
                    grid_type: "area",
                    solar_type: "area",
                    ens_type: "area",
                    irr_unit: "W/m2",
                    solar_unit: "kW",
                    grid_unit: "kW",
                    ens_unit: "kW",
                    axis_y1: 'Power (kW)',
                    axis_y2: 'Irradiation (W/m2)',
                    solar_tag: 'Solar Power',
                    grid_tag: 'Grid Power',
                    ens_tag: 'Energy not Supply',
                    xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-',
                    opacity: 0.8
                }
            }
            plot_chart = data_chart.chart_5m
        } else if (chart_mode === "daily-h") {
            daplot = {
                XLabel: data_chart.chart_hour.XLabel,
                EnergyAC: [],
                EnergyGrid: [],
                ENS: [],
                IRR: [],
                CODData: null,
                Chart1_Style: {
                    irr_type: "line",
                    grid_type: "column",
                    solar_type: "column",
                    ens_type: "column",
                    irr_unit: "W/m2",
                    solar_unit: "kWh",
                    grid_unit: "kWh",
                    ens_unit: "kWh",
                    axis_y1: 'Energy (kWh)',
                    axis_y2: 'Irradiation (Wh/m2)',
                    solar_tag: 'Solar Energy',
                    grid_tag: 'Grid Energy',
                    ens_tag: 'Energy not Supply',
                    xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: 'vertical',
                    opacity: 0.8
                }
            }
            plot_chart = data_chart.chart_hour
        } else if (chart_mode === "monthly") {
            daplot = {
                XLabel: data_chart.chart_month.XLabel,
                EnergyAC: [],
                EnergyGrid: [],
                ENS: [],
                IRR: [],
                CODData: { CODIndex_Start: data_chart.chart_month.CODData ? data_chart.chart_month.CODData.CODIndex_Start : null, CODIndex_Stop: data_chart.chart_month.CODData ? data_chart.chart_month.CODData.CODIndex_Stop : null },
                Chart1_Style: {
                    irr_type: "line",
                    grid_type: "column",
                    solar_type: "column",
                    ens_type: "column",
                    irr_unit: "Wh/m2",
                    solar_unit: "kWh",
                    grid_unit: "kWh",
                    ens_unit: "kWh",
                    axis_y1: 'Energy (kWh)',
                    axis_y2: 'Irradiation (Wh/m2)',
                    solar_tag: 'Solar Energy',
                    grid_tag: 'Grid Energy',
                    ens_tag: 'Energy not Supply',
                    xinterval: 'day', xformat: 'DD', tooltip_header: 'Date', tooltip_format: 'DD MMM YYYY', indexlabel: 'vertical',
                    opacity: 0.8
                }
            }
            plot_chart = data_chart.chart_month
        } else if (chart_mode === "yearly") {
            daplot = {
                XLabel: data_chart.chart_year.XLabel,
                EnergyAC: [],
                EnergyGrid: [],
                ENS: [],
                IRR: [],
                CODData: { CODIndex_Start: data_chart.chart_year.CODData ? data_chart.chart_year.CODData.CODIndex_Start : null, CODIndex_Stop: data_chart.chart_year.CODData ? data_chart.chart_year.CODData.CODIndex_Stop : null },
                Chart1_Style: {
                    irr_type: "line",
                    grid_type: "column",
                    solar_type: "column",
                    ens_type: "column",
                    irr_unit: "Wh/m2",
                    solar_unit: "MWh",
                    grid_unit: "MWh",
                    ens_unit: "MWh",
                    axis_y1: 'Energy (MWh)',
                    axis_y2: 'Irradiation (Wh/m2)',
                    solar_tag: 'Solar Energy',
                    grid_tag: 'Grid Energy',
                    ens_tag: 'Energy not Supply',
                    xinterval: 'month', xformat: 'MMM', tooltip_header: 'Month', tooltip_format: 'MMM YYYY', indexlabel: 'vertical',
                    opacity: 0.8
                }
            }
            plot_chart = data_chart.chart_year
        }

        if (plot_chart !== null) {
            let charttag = {
                solar: "solar_active",
                grid_active: "grid_active"
            }
            if (chart_mode === "daily-5m") {
                charttag.solar = "solar_active"
                charttag.grid = "grid_active"
            } else {
                charttag.solar = "solar"
                charttag.grid = "grid"
            }
            if (plot_chart.Data !== null) {
                for (let i = 0; i < plot_chart.Data.length; i++) {
                    const dx = new Date(plot_chart.Data[i].x)

                    daplot.IRR.push({ x: dx, y: plot_chart.Data[i].irr })
                    daplot.EnergyAC.push({ x: dx, y: plot_chart.Data[i][charttag.solar] })
                    daplot.EnergyGrid.push({ x: dx, y: plot_chart.Data[i][charttag.grid] })
                    daplot.ENS.push({ x: dx, y: plot_chart.Data[i]['ens'] })
                }
            }
            setChart_plot(daplot)
        } else {
            setChart_plot(daplot)
        }
    }, [chart_mode, data_chart]);

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content     bg-primary">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-monitor-dashboard color-orange"></i> Overview</h4>
                                    <p className="mb-1">Production overview</p>
                                    <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {props.server_update !== "-" ? moment(new Date(props.server_update)).format("YYYY-MM-DD HH:mm:ss") : "Unknown"}</h6>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="d-flex flex-wrap">
                        <CardOverview
                            header="Irradiation"
                            unit_1={<div>Wh/m<sup>2</sup></div>}
                            unit_2={<div>Wh/m<sup>2</sup></div>}
                            unit_3={<div>Wh/m<sup>2</sup></div>}
                            unit_4={<div>Wh/m<sup>2</sup></div>}
                            tagname="summary_irr"
                            icon={<i className="fas fa-sun color-orange"></i>}
                            data_irr_error={props.data_calculation.irr_error_lock}
                            data_calculation={props.data_calculation}
                        />
                        <CardOverview
                            header="Solar Energy"
                            unit_1="kWh"
                            unit_2="MWh"
                            unit_3="MWh"
                            unit_4="MWh"
                            tagname="summary_energy"
                            icon={<i className="fas fa-bolt color-yellow"></i>}
                            data_calculation={props.data_calculation}
                        />
                        <CardOverview
                            header="Energy not Supply"
                            unit_1="kWh"
                            unit_2="MWh"
                            unit_3="MWh"
                            unit_4="MWh"
                            tagname="summary_ens"
                            icon={<i className="fas fa-bolt color-grey"></i>}
                            data_calculation={props.data_calculation}
                        />
                        <CardOverview
                            header={<div>CO<sub>2</sub> Reduction</div>}
                            unit_1={<div>kgCO<sub>2</sub></div>}
                            unit_2={<div>tonCO<sub>2</sub></div>}
                            unit_3={<div>tonCO<sub>2</sub></div>}
                            unit_4={<div>tonCO<sub>2</sub></div>}
                            tagname="summary_co2"
                            icon={<i className="mdi mdi-molecule-co2 color-green"></i>}
                            data_calculation={props.data_calculation}
                        />
                        <CardOverview
                            header="Estimate Saving"
                            unit_1="THB"
                            unit_2="THB"
                            unit_3="THB"
                            unit_4="THB"
                            tagname="summary_saving"
                            icon={<i className="mdi mdi-account-cash-outline color-sky"></i>}
                            data_calculation={props.data_calculation}
                        />
                    </div>
                    <div className="row mb-1">
                        <div className="col-xl-12">
                            <hr className="new-section-xs mb-2" />
                            <h4 className="mb-1"><i className="mdi mdi-chart-line color-orange"></i> Energy Produce</h4>
                            <p className="mb-3">Realtime energy produce chart</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="d-flex justify-content-start gap-1 mt-0 mb-2">
                            <button className={"btn btn-sm " + (chart_mode === "daily-5m" ? "btn-info" : "btn-light")} type="button" onClick={e => setChart_mode('daily-5m')}>Daily-5m</button>
                            <button className={"btn btn-sm " + (chart_mode === "daily-h" ? "btn-info" : "btn-light")} type="button" onClick={e => setChart_mode('daily-h')}>Daily-h</button>
                            <button className={"btn btn-sm " + (chart_mode === "monthly" ? "btn-info" : "btn-light")} type="button" onClick={e => setChart_mode('monthly')}>Monthly</button>
                            <button className={"btn btn-sm " + (chart_mode === "yearly" ? "btn-info" : "btn-light")} type="button" onClick={e => setChart_mode('yearly')}>Yearly</button>
                        </div>
                        <div className="col-12 col-xl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Power Vs Irradiation</h5>
                                    <CanvasJSReact_EnergyProduce
                                        solorpower={chart_plot.EnergyAC}
                                        enspower={chart_plot.ENS}
                                        irr={chart_plot.IRR}
                                        xlabel={chart_plot.XLabel}
                                        chart_style={chart_plot.Chart1_Style}
                                        cod={chart_plot.CODData}
                                    ></CanvasJSReact_EnergyProduce>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-xl-6">
                            <div className="card card-common mb-3">
                                <div className="card-body pb-3">
                                    <h5 className="card-title font-weight-bold mb-0"><i className="mdi mdi-chart-line color-sky"></i> Energy Balance</h5>
                                    <CanvasJSReact_EnergyBalance
                                        solorpower={chart_plot.EnergyAC}
                                        gridpower={chart_plot.EnergyGrid}
                                        xlabel={chart_plot.XLabel}
                                        chart_style={chart_plot.Chart1_Style}
                                        cod={chart_plot.CODData}
                                    ></CanvasJSReact_EnergyBalance>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ScrollToTopButton />
        </div>
    )
}
export default MeasurementOverview